/**
 * Tabs component.
 */

define('libs/tabs',[],function() {

    'use strict';

    var SETTINGS = {
        tabActiveClass: 'tab-active',
        contentActiveClass: 'content-active'
    };

    var Tabs = function($root, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.$root = $root;

        // handle clicks on tabs.
        this.$root.on('click', this.onClick.bind(this));

        // get active tab.
        this.activeTab = this.$root.find('.' + this.settings.tabActiveClass);

        // get active content.
        this.activeContent = $(this.activeTab.attr('href'));
    };

    /**
     * Handle the click event on a tab.
     * @param {Event} event The click event.
     */
    Tabs.prototype.onClick = function(event) {
        var tab = $(event.target),
            targetID = tab.attr('href'),
            targetElement;

        if (targetID) {
            targetElement = $(targetID);
            if (targetElement) {
                event.preventDefault();
                event.stopPropagation();
                this.show(tab, targetElement);
            }
        }
    };

    /**
     * Show a tab's content.
     * Set tab as active.
     */
    Tabs.prototype.show = function(tab, content) {
        this.activeTab.removeClass(this.settings.tabActiveClass);
        this.activeContent.removeClass(this.settings.contentActiveClass);
        tab.addClass(this.settings.tabActiveClass);
        content.addClass(this.settings.contentActiveClass);
        this.activeTab = tab;
        this.activeContent = content;

        $(document.body).trigger('tab.active', {
            tab: this.activeTab,
            content: this.activeContent
        });
    };

    return Tabs;
});

